// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"433":"64d5d2f2","590":"82639bfb","852":"ab5e16f0","882":"f0bce8c8"}[chunkId] + ".chunk.css";
};